module.exports = __webpack_public_path__ + "images/null-booking-logs.d589c3caecd3a05cbce69dcad5785569.png";